// extracted by mini-css-extract-plugin
export default {"wrap":"email_sender_contact_badge_wrap__kf03Q","known":"email_sender_contact_badge_known__8iXSX","trigger":"email_sender_contact_badge_trigger__27Dek"};